import api from './api'

const autoscheduleApi = config =>
  api({
    ...config,
    baseURL: process.env.SCHEDULE_SERVER,
  })

const getAutoscheduleConfig = () =>
  autoscheduleApi({
    method: 'get',
    url: '/configuration',
  })

const getStatGraph = params =>
  autoscheduleApi({
    method: 'get',
    url: '/stat',
    params,
  })

const getForecastGraph = params =>
  autoscheduleApi({
    method: 'get',
    url: '/forecast',
    params,
  })

const updateForecastGraph = data =>
  autoscheduleApi({
    method: 'put',
    url: '/forecast',
    data,
  })

const getEmployers = params =>
  autoscheduleApi({
    method: 'get',
    url: '/employers',
    params,
  })

const getSchedule = params =>
  autoscheduleApi({
    method: 'get',
    url: '/employers/schedules',
    params,
  })

const getDefaultSchedule = data =>
  autoscheduleApi({
    method: 'post',
    url: '/schedule/make/default',
    data,
  })

const getAutoSchedule = data =>
  autoscheduleApi({
    method: 'post',
    url: '/schedule/make/auto',
    data,
  })

const resetSchedule = data =>
  autoscheduleApi({
    method: 'post',
    url: '/schedule/reset',
    data,
  })

const saveSchedule = data =>
  autoscheduleApi({
    method: 'post',
    url: '/schedule/save',
    data,
  })

const createScheduleItem = data =>
  autoscheduleApi({
    method: 'post',
    url: '/schedule',
    data,
  })

const updateScheduleItem = data =>
  autoscheduleApi({
    method: 'put',
    url: '/schedule',
    data,
  })

const deleteScheduleItem = id =>
  autoscheduleApi({
    method: 'delete',
    url: '/schedule',
    params: { id },
  })

const createOption = data =>
  autoscheduleApi({
    method: 'post',
    url: '/options',
    data,
  })

const updateOption = (data, optionId) =>
  autoscheduleApi({
    method: 'put',
    url: `/options/${optionId}`,
    data,
  })

const getOptions = params =>
  autoscheduleApi({
    method: 'get',
    url: '/options/',
    params,
  })

const createWishItem = data =>
  autoscheduleApi({
    method: 'post',
    url: '/wish',
    data,
  })

const deleteWishItem = id =>
  autoscheduleApi({
    method: 'delete',
    url: `/wish/${id}`,
  })

const saveRating = data =>
  autoscheduleApi({
    method: 'post',
    url: '/rating/manager',
    data,
  })

const getRatings = params =>
  autoscheduleApi({
    method: 'get',
    url: '/rating',
    params,
  })

const getScheduleOpinion = params =>
  autoscheduleApi({
    method: 'get',
    url: '/schedule/opinion',
    params,
  })

const sendNeighbourRequest = data =>
  autoscheduleApi({
    method: 'post',
    url: '/neighbour/request',
    data,
  })

const acceptNeighbourRequest = data =>
  autoscheduleApi({
    method: 'post',
    url: '/neighbour/accept',
    data,
  })

const declineNeighbourRequest = data =>
  autoscheduleApi({
    method: 'post',
    url: '/neighbour/decline',
    data,
  })

const getCategories = params =>
  autoscheduleApi({
    method: 'get',
    url: '/available/services',
    params,
  })

const getWorkplacesNumber = unitId =>
  api({
    method: 'get',
    url: `/api/crm/unit/${unitId}/workplace`,
  })

const getQuarantineWorkplaces = () =>
  autoscheduleApi({
    method: 'get',
    url: '/quarantine-workplaces',
  })

const deleteQuarantineWorkplaces = settingId =>
  autoscheduleApi({
    method: 'delete',
    url: `/quarantine-workplaces/${settingId}`,
  })

const saveQuarantineWorkplaces = data =>
  autoscheduleApi({
    method: 'post',
    url: '/quarantine-workplaces',
    data,
  })

const sendRememberNotify = data =>
  api({
    method: 'post',
    baseURL: process.env.NOTIFY_SERVER,
    url: '/template/remember-wishes/send',
    data,
  })

const getWishesData = params =>
  autoscheduleApi({
    method: 'get',
    url: '/employers/wishes',
    params,
  })

const getWishesOfEmployer = params =>
  autoscheduleApi({
    method: 'get',
    url: '/wish',
    params,
  })

export const passwordConfirm = data =>
  api({
    method: 'post',
    url: '/api/crm/auth/login',
    data,
  })

export {
  getWishesData,
  getWishesOfEmployer,
  getAutoscheduleConfig,
  getQuarantineWorkplaces,
  saveQuarantineWorkplaces,
  deleteQuarantineWorkplaces,
  getStatGraph,
  getForecastGraph,
  updateForecastGraph,
  getEmployers,
  getCategories,
  getSchedule,
  getDefaultSchedule,
  getAutoSchedule,
  resetSchedule,
  createScheduleItem,
  updateScheduleItem,
  deleteScheduleItem,
  createWishItem,
  deleteWishItem,
  createOption,
  updateOption,
  getScheduleOpinion,
  getOptions,
  saveRating,
  getRatings,
  sendNeighbourRequest,
  acceptNeighbourRequest,
  declineNeighbourRequest,
  getWorkplacesNumber,
  saveSchedule,
  sendRememberNotify,
}
